{
	"noCategory": "Sem categoria",
	"save": "Salvar alterações",
	"add": "Adicionar produto",
	"edit": "Editar produto",
	"equivalentProduct": "Produto equivalente",
	"searchProduct": "Pesquise por produtos",
	"name": "Nome",
	"namePlaceholder": "Nome do produto",
	"category": "Categoria",
	"categoryPlaceholder": "Categoria do produto",
	"productPrice": "Valor do produto",
	"description": "Descrição",
	"descriptionPlaceholder": "Descrição do produto",
	"mountableProduct": "Produto montável",
	"zigCategory": "Categoria Zig",
	"sku": "SKU",
	"validadeField": "Campo obrigatório",
	"product": "Produto",
	"maxCount": "Qtd. máxima selecionável",
	"price": "Valor",
	"addItem": "Adicionar item",
	"title": "Título",
	"titlePlaceholder": "Titulo da etapa",
	"pricing": "Precificação",
	"sum": "Soma",
	"average": "Média",
	"higher": "Maior",
	"min": "Min",
	"max": "Max",
	"addItemName": "Item {{length}}",
	"step": "ETAPA {{index}}"
}
